import { useAppSelector } from "@/redux/hooks";
import ConfigUtils from "@/utils/ConfigUtils";
import { useSplitClient } from "@splitsoftware/splitio-react";

export const useAsyncCheckoutEnabled = () => {
  const userProfile = useAppSelector((state) => state.userProfile);
  const appId = useAppSelector(
    (state) => state.appConfig?.brandAppConfig?.appId
  );
  const appType = useAppSelector(
    (state) => state.appConfig?.brandAppConfig?.appType
  );
  const splitIO = useSplitClient();
  const syncOptionForRetailerTreatment = splitIO.client?.getTreatment(
    "brandclub_async_checkout",
    {
      email: userProfile?.email ?? "",
      appId: appId ?? "",
      appType: appType ?? "",
    }
  ) as "on" | "off" | "debug";

  return {
    enabled:
      ["on", "debug"].includes(syncOptionForRetailerTreatment) ||
      window.location.href.includes(
        import.meta.env.VITE_APP_LOCALHOST_UI_URL
      ) ||
      ConfigUtils.getAppStage() === "beta",
    debug: syncOptionForRetailerTreatment === "debug",
  };
};
